import {
  Component, Inject, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { MENU_DATA, SidenavMenuRef } from '@firestitch/sidenav';

import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

import { CreateComponent } from '@app/environment/modules/create/components/create';
import { Environment } from '@app/common/interfaces';
import { AclPermission } from '@app/common';

import { EnvironmentSwitchComponent } from '../environment-switch/environment-switch.component';


@Component({
  templateUrl: './environment-menu.component.html',
  styleUrls: ['./environment-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentMenuComponent implements OnDestroy {

  public environments: Environment[] = [];
  public AclPermission = AclPermission;

  private _destroy$ = new Subject();

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private _cd: ChangeDetectorRef,
    public menuRef: SidenavMenuRef<EnvironmentMenuComponent>,
    @Inject(MENU_DATA) public data: {
      environment: Environment;
      hasSettingsAccess: boolean;
      environments: Environment[];
    },
  ) {
    this.environments = data.environments;
  }

  public close(): void {
    this.menuRef.close();
  }

  public create(): void {
    this.close();

    this.dialog.open(CreateComponent, {
      data: { autofocus: false },
    });
  }

  public switch(): void {
    this.close();
    this.dialog.open(EnvironmentSwitchComponent)
      .afterClosed()
      .pipe(
        filter((response) => !!response),
        takeUntil(this._destroy$),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
